import { createFileRoute, useLocation } from '@tanstack/react-router';
import { auth } from '@/auth';
import { ResetPasswordForm } from 'ht-sdk/auth/client';

export const Route = createFileRoute('/reset-password')({
	component: RouteComponent,
});

function RouteComponent() {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.searchStr);
	const resetToken = searchParams.get('code') ?? '';
	const email = searchParams.get('email') ?? '';

	return (
		<div className="flex size-full min-h-screen items-center justify-center bg-gray-100">
			<div className="w-lg rounded-2xl border border-gray-200 bg-white p-8 shadow-lg">
				<ResetPasswordForm auth={auth} resetToken={resetToken} email={email} />
			</div>
		</div>
	);
}
